import styled from 'styled-components';

import { th } from '@yoweb/ui/styles/utils/theme';

const Th = styled.th`
  padding: ${th.getSpace('normal1')};
  background-color: #d9d9d9;
  border: 1px solid;
  border-color: ${th.getColor('base1000')};
`;

export { Th };
export default Th;
